<template>
  <v-overlay absolute light opacity="0" z-index="1">
    <div class="text-center">
      <v-row no-gutters align="stretch" justify="center" class="mb-3">
        <v-img src="@/assets/img/empty/4.svg"
               max-width="160"
               class="mb-5 justify-center"
        />
      </v-row>
      <div class="text-h6 black--text">Статьи не найдены</div>
      <div class="body-2 grey--text">
        Мы добавим их позже. Если мы можем помочь Вам - создайте новый запрос.
      </div>
    </div>
  </v-overlay>
</template>

<script>
export default {
  name: 'EmptyHelp',
  data: () => ({

  }),
}
</script>